// Copyright (c) 2017 Comsearch, Inc., All rights reserved

//  for DataTable to have a unique id.
const prepData = arr => arr.map(d => ({
  ...d,
  uniqueId: 'rcnId',
}))

export default prepData
